import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    value: 'Pendente',
    text: 'Pendente',
    ...ChipColors.wait,
  },
  {
    value: 'Finalizado',
    text: 'Finalizado',
    ...ChipColors.success,
  },
  {
    value: 'Cancelado pelo usuário',
    text: 'Cancelado pelo usuário',
    ...ChipColors.danger,
  },
];
